import React, { Fragment } from 'react';
import classNames from 'classnames';

export interface RepeatComponentProps {
    /**
     * Css класс списка.
     */
    className?: string;
    /**
     * Количество повторений.
     */
    numberRepetitions: number;
    /**
     * Компонент для рендеринга.
     */
    children: React.ReactElement;
}

/**
 * Рендеринг компонента несколько раз.
 */
export const RepeatComponent = (props: RepeatComponentProps) => {
    const className = classNames('alfaListRepeat', props.className);
    const { numberRepetitions, children } = props;

    return (
        <div className={className}>
            {[...Array(numberRepetitions)].map((item, index) => (
                <Fragment key={index}>{children}</Fragment>
            ))}
        </div>
    );
};
